import { ChangeEvent as ReactChangeEvent, useCallback, useState } from 'react';
import { PositionID, PositionNames } from '../../../common/Positions/Constants';

const COPY_SIGN_UP_URL_LABELS = {
  COPY: 'Copy Sign-Up URL',
  COPIED: 'Copied Sign-Up URL',
};

export const AdminTools = () => {
  const [selectedPositionID, setSelectedPositionID] = useState<PositionID | undefined>(undefined);
  const onSelectedPositionIDChange = useCallback(({ target: { value } }: ReactChangeEvent<HTMLSelectElement>) => {
    if (value && value in PositionID) {
      setSelectedPositionID(value as PositionID);
    }
  }, []);
  const [signUpURLCopyLabel, setSignUpURLCopyLabel] = useState<string>(COPY_SIGN_UP_URL_LABELS.COPY);
  const onCopySignUpURL = useCallback(() => {
    if (selectedPositionID) {
      window.navigator.clipboard.writeText(`${window.location.origin}?position_id=${selectedPositionID}`).then(() => {
        setSignUpURLCopyLabel(COPY_SIGN_UP_URL_LABELS.COPIED);
        setTimeout(() => {
          setSignUpURLCopyLabel(COPY_SIGN_UP_URL_LABELS.COPY);
        }, 2000);
      });
    }
  }, [selectedPositionID]);

  return (
    <div>
      <h3>Tools</h3>
      <div>
        <h5>Create Sign-Up Link:</h5>
        <select value={selectedPositionID || ''} onChange={onSelectedPositionIDChange}>
          <option value="">Select Position</option>
          {Object.keys(PositionID).map((posID) => (
            <option key={posID} value={posID}>
              {PositionNames[posID as PositionID]}
            </option>
          ))}
        </select>
        <button disabled={!selectedPositionID} onClick={onCopySignUpURL}>
          {signUpURLCopyLabel}
        </button>
      </div>
    </div>
  );
};
